import BaseQuizGame from "./BaseQuizGame.js";
import { getFlagPath } from "../utils/FlagUtils.js";

export default class CapitalNerdHard extends BaseQuizGame {
	constructor() {
		super('capitalnerdhard', '.capital-nerd-hard', {
			passportStamp: "capital",
			gameNameKey: "home.capitalNerd",
			modeLabelKey: "home.hard",
			mode: "hard",
			shareEmoji: "🟥",
			slug: "capital-nerd-hard"
		});
		if (!this.page) return;

		this.init();
	}

	buildProposalEntry(country) {
		return { code: country.code, name: country.name, capital: country.capital };
	}

	getAnswerLabel(proposal) {
		return proposal.capital;
	}

	buildError(guessBtn) {
		return {
			countryName: this.rightAnswer.name,
			correctCode: this.rightAnswer.code,
			correctCapital: this.rightAnswer.capital,
			guessedCapital: guessBtn.textContent
		};
	}

	renderErrorItem(error) {
		return `
			<div class="error-item">
				<div class="error-country">${error.countryName}</div>
				<div class="error-flag correct">
					<img src="${getFlagPath(error.correctCode)}" alt="${error.countryName}">
				</div>
				<div class="error-details">
					<div class="error-answer-text correct">${error.correctCapital}</div>
					<div class="error-answer-text wrong">${error.guessedCapital}</div>
				</div>
			</div>
		`;
	}
}
